import React, { useState } from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { Button } from "@emisgroup/ui-button";
import { ToggleButton, ToggleButtons } from "@emisgroup/ui-toggle-buttons";

import { useSelections } from "../../../../hooks/useSelections";
import { INCLUSION } from "./Types";
import { InsightTable } from "./InsightTable";
import Close from "~icons/ic/baseline-close";

import "./Style.scss";

const inclusionTabList: string[] = [
  INCLUSION.INC,
  INCLUSION.EXC,
];

type InsightHeader = {
  name: string;
};

const toggleButtons: InsightHeader[] = [
  { name: "Gender" },
  { name: "IMD" },
  { name: "Ethnicity" },
  { name: "1st Language" },
  { name: "Age" }
];

export const Insights: React.FC<{executionType: string}> = ({ executionType }) => {
  const { t: translate } = useTranslation();
  const [inclusion, setInclusion] = useState<string>(INCLUSION.INC);
  const [showInsights, setShowInsights] = useState(false);
  const [filterCriteria, setFilterCriteria ] = useState<string>(toggleButtons[0].name);
  const [, emit] = useSelections();

  return (
    <div className="execution-insights">
      <div className="execution-insights__header">
        <h5 className="execution-insights__label">{translate("Insights.Title")}</h5>
        <div className="execution-insights__header__right">
          <ToggleButtons type="single" value={inclusion} onValueChange={(value): void => {setInclusion(value);}}>
            {inclusionTabList.map((tab: string) => {
              return (<ToggleButton value={tab} key={tab}>{tab}</ToggleButton>);
            })}
          </ToggleButtons>
          <Button className="execution-insights__close" borderless={true} circular={true}
            data-testid="insightsCloseButton"
            id="insightsCloseButton"
            onClick={(): void => { setShowInsights(false); emit([]); }}
          >
            <Close title="close"/>
          </Button>
        </div>
      </div>
      <ToggleButtons
        type="single"
        value={filterCriteria}
        className="insights-toggle-buttons"
        onValueChange={(value): void => setFilterCriteria(value)}>
        {toggleButtons.map((option: InsightHeader) => {
          return (
            <ToggleButton value={option.name} key={option.name}>
              {option.name}
            </ToggleButton>
          );
        })}
      </ToggleButtons>
      <InsightTable
        showInsights={showInsights}
        setShowInsights={setShowInsights}
        filterCriteria={filterCriteria}
        inclusion={inclusion}
        executionType={executionType}
      />
    </div>
  );
};
